export default "__VITE_ASSET__sx5Ec2KB__"